import type { SessionsAsset } from '@carboncopyco/data';
import { InlineLink, TooltipBubble } from '@carboncopyco/ui';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { TableInfoIcon } from './TableInfoIcon';
import { getInfoTooltipText } from './utils';

type AssetNameLinkProps = {
  to?: string;
  label: string;
  asset: SessionsAsset;
  assetType: 'tour' | 'demo' | 'playbook';
  truncateWidth?: number;
};

export const AssetNameLink = ({
  to,
  label,
  asset,
  assetType,
  truncateWidth = 170,
}: AssetNameLinkProps) => {
  const isDisabled = asset.status === 'deleted' || asset.status === 'inactive';
  return (
    <div
      className={classNames(
        'flex items-center gap-1.5',
        isDisabled ? 'text-ds-natural-300' : 'text-ds-natural-600'
      )}
    >
      <TooltipBubble
        placement="top-start"
        title={label}
      >
        <InlineLink
          underline={!(isDisabled || !to)}
          disabled={isDisabled}
          label={label}
          as={Link}
          truncateWidth={truncateWidth}
          to={isDisabled ? undefined : to}
        />
      </TooltipBubble>
      {isDisabled && (
        <TableInfoIcon label={getInfoTooltipText({ assetType })} />
      )}
    </div>
  );
};
